export default function initSticky() {
    const header = document.querySelector('.header');

    window.addEventListener('scroll', (event) => {});
    const stickyHeader = "header-fixed";

    onscroll = (event) => { 
         const currentScroll = window.pageYOffset;
          if (currentScroll <= 0) {
            header.classList.remove(stickyHeader);
            return;
          } else {
            header.classList.add(stickyHeader);
          }
    };
}